<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.77 17.91" class="icon" v-bind:class="{'icon--active': active}">
        <title>list</title>
        <path d="M2,4.58a.8.8,0,0,1-.55-.22L0,2.86,1.09,1.78,2,2.66,4.06,0,5.27,1,2.64,4.29a.77.77,0,0,1-.56.29H2"/>
        <path d="M2,11.21A.76.76,0,0,1,1.49,11L0,9.49,1.09,8.41,2,9.29,4.06,6.63l1.21,1L2.64,10.92a.77.77,0,0,1-.56.29H2"/>
        <path d="M2,17.91a.76.76,0,0,1-.55-.23L0,16.19,1.09,15.1,2,16l2.09-2.66,1.21.95L2.64,17.62a.81.81,0,0,1-.56.29Z"/>
        <line x1="8.4" y1="2.27" x2="14.02" y2="2.27"
              style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px"/>
        <line x1="8.4" y1="8.92" x2="14.02" y2="8.92"
              style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px"/>
        <line x1="8.4" y1="15.72" x2="14.02" y2="15.72"
              style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px"/>
    </svg>
</template>

<script>
    export default {
        name: "IconList",

        props: {
            active: {
                type: Boolean,
                default: false
            }
        },
    }
</script>

<style lang="scss" scoped>
    .icon {
        path {
            fill: #231f20;
        }

        line {
            stroke: #231f20
        }
    }

    .icon--active {
        path {
            fill: $primary;
        }

        line {
            stroke: $primary
        }
    }
</style>
